// ======================================================
// HEADER (BISON) — hamburger, overlay, mega menu (Shop+Collections), inline predictive search
// ======================================================

(function() {
  function debounce(fn, wait) {
    var t;
    return function() {
      var ctx = this, args = arguments;
      clearTimeout(t);
      t = setTimeout(function() { fn.apply(ctx, args); }, wait);
    };
  }

  function initHeader(container) {
    if (!container || container.dataset.headerBisonInit) return;
    container.dataset.headerBisonInit = '1';

    var hamburger = container.querySelector('.hamburger-menu');
    var navbar = container.querySelector('.custom-navbar');
    var overlay = container.querySelector('.mobile-overlay');
    var closeBtn = container.querySelector('.close-menu');
    var navItemsWithMenu = container.querySelectorAll('.custom-nav-item');

    function measureHiddenMenuWidth(menu) {
      if (!menu) return 0;
      var prevDisplay = menu.style.display;
      var prevVisibility = menu.style.visibility;
      var prevPointerEvents = menu.style.pointerEvents;
      var hadSelection = menu.classList.contains('has-selection');
      var content = menu.querySelector('.mega-menu-content');
      var collections = menu.querySelector('.collections-content');
      menu.style.visibility = 'hidden';
      menu.style.pointerEvents = 'none';
      menu.style.display = 'block';
      // Measure at expanded desktop width so right-edge items don't overflow on hover.
      menu.classList.add('has-selection');
      if (content) content.classList.add('has-selection');
      if (collections) collections.classList.add('has-selection');
      var width = menu.getBoundingClientRect().width || 0;
      if (!hadSelection) {
        menu.classList.remove('has-selection');
        if (content) content.classList.remove('has-selection');
        if (collections) collections.classList.remove('has-selection');
      }
      menu.style.display = prevDisplay;
      menu.style.visibility = prevVisibility;
      menu.style.pointerEvents = prevPointerEvents;
      return width;
    }

    function updateMegaMenuAlignment() {
      if (window.innerWidth <= 991) return;
      var viewportWidth = window.innerWidth || document.documentElement.clientWidth;
      navItemsWithMenu.forEach(function(item) {
        var mega = item.querySelector('.mega-menu');
        item.classList.remove('mega-align-right');
        if (!mega) return;
        var megaWidth = measureHiddenMenuWidth(mega);
        if (!megaWidth) return;
        var itemRect = item.getBoundingClientRect();
        var overflowRight = itemRect.left + megaWidth > viewportWidth - 8;
        if (overflowRight) item.classList.add('mega-align-right');
      });
    }

    function resetMegaMenuState(scope) {
      if (!scope) return;
      scope.querySelectorAll('.mega-menu-item[data-key]').forEach(function(item) { item.classList.remove('active'); });
      scope.querySelectorAll('.collections-panel').forEach(function(panel) { panel.classList.remove('active'); });
      scope.querySelectorAll('.collections-content').forEach(function(box) { box.classList.remove('has-selection'); });
      scope.querySelectorAll('.mega-menu-content').forEach(function(content) { content.classList.remove('has-selection'); });
      scope.querySelectorAll('.mega-menu').forEach(function(menu) { menu.classList.remove('has-selection'); });
      scope.querySelectorAll('.collections-panel .mega-menu-item').forEach(function(link) { link.classList.remove('active'); });
    }

    function closeMenu() {
      if (hamburger) hamburger.classList.remove('active');
      if (navbar) navbar.classList.remove('active');
      if (overlay) overlay.classList.remove('active');
      document.body.style.overflow = '';
      navItemsWithMenu.forEach(function(item) {
        item.classList.remove('open');
        var mega = item.querySelector('.mega-menu');
        if (mega) mega.classList.remove('active');
        resetMegaMenuState(item);
      });
    }

    if (hamburger && navbar) {
      hamburger.addEventListener('click', function(e) {
        e.stopPropagation();
        hamburger.classList.toggle('active');
        navbar.classList.toggle('active');
        if (overlay) overlay.classList.toggle('active');
        document.body.style.overflow = navbar.classList.contains('active') ? 'hidden' : '';
      });
    }

    if (overlay) overlay.addEventListener('click', closeMenu);
    if (closeBtn) closeBtn.addEventListener('click', closeMenu);

    navItemsWithMenu.forEach(function(item) {
      var link = item.querySelector('.custom-nav-link');
      var megaMenu = item.querySelector('.mega-menu');

      if (megaMenu && link) {
        link.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          resetMegaMenuState(item);

          if (window.innerWidth <= 991) {
            var isOpen = item.classList.contains('open');
            if (isOpen) {
              item.classList.remove('open');
              megaMenu.classList.remove('active');
              return;
            }
            navItemsWithMenu.forEach(function(otherItem) {
              otherItem.classList.remove('open');
              var otherMenu = otherItem.querySelector('.mega-menu');
              if (otherMenu) otherMenu.classList.remove('active');
            });
            item.classList.add('open');
            megaMenu.classList.add('active');
          } else {
            navItemsWithMenu.forEach(function(otherItem) {
              otherItem.classList.remove('open');
              var otherMenu = otherItem.querySelector('.mega-menu');
              if (otherMenu && otherMenu !== megaMenu) otherMenu.classList.remove('active');
            });
            megaMenu.classList.toggle('active');
            item.classList.toggle('open', megaMenu.classList.contains('active'));
          }
        });
      }
    });

    document.addEventListener('click', function(e) {
      if (!e.target.closest('.custom-nav-item') && window.innerWidth > 991) {
        navItemsWithMenu.forEach(function(item) {
          item.classList.remove('open');
          var mega = item.querySelector('.mega-menu');
          if (mega) mega.classList.remove('active');
        });
      }
    });

    updateMegaMenuAlignment();
    window.addEventListener('resize', debounce(updateMegaMenuAlignment, 120));

    container.querySelectorAll('.mega-menu').forEach(function(mega) {
      mega.addEventListener('click', function(e) { e.stopPropagation(); });
    });

    /* Shop + Collections linking - dynamic 3-level menu */
    container.querySelectorAll('.mega-menu').forEach(function(mega) {
      var shopItems = mega.querySelectorAll('.mega-menu-item[data-key]');
      var plainShopItems = mega.querySelectorAll('.mega-column:first-child .mega-menu-item:not([data-key])');
      var panels = mega.querySelectorAll('.collections-panel[data-parent-key]');
      var collectionsBox = mega.querySelector('.collections-content');
      var megaContent = mega.querySelector('.mega-menu-content');

      if (shopItems.length === 0 || panels.length === 0 || !collectionsBox || !megaContent) return;

      function showPanel(key) {
        mega.classList.add('has-selection');
        collectionsBox.classList.add('has-selection');
        megaContent.classList.add('has-selection');
        panels.forEach(function(panel) {
          panel.classList.toggle('active', panel.getAttribute('data-parent-key') === key);
        });
      }

      function activateShopRow(item) {
        shopItems.forEach(function(i) { i.classList.remove('active'); });
        item.classList.add('active');
        var key = item.getAttribute('data-key');
        if (key) showPanel(key);
      }

      function clearPanelSelection() {
        shopItems.forEach(function(i) { i.classList.remove('active'); });
        panels.forEach(function(panel) { panel.classList.remove('active'); });
        collectionsBox.classList.remove('has-selection');
        megaContent.classList.remove('has-selection');
        mega.classList.remove('has-selection');
      }

      shopItems.forEach(function(item) {
        item.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          activateShopRow(item);
        });
        item.addEventListener('mouseenter', function() {
          if (window.innerWidth <= 991) return;
          activateShopRow(item);
        });
      });

      plainShopItems.forEach(function(item) {
        item.addEventListener('mouseenter', function() {
          if (window.innerWidth <= 991) return;
          clearPanelSelection();
        });
        item.addEventListener('click', function() {
          clearPanelSelection();
        });
      });

      mega.querySelectorAll('.collections-panel .mega-menu-item').forEach(function(link) {
        link.addEventListener('click', function() {
          var panel = link.closest('.collections-panel');
          if (!panel) return;
          panel.querySelectorAll('.mega-menu-item').forEach(function(i) { i.classList.remove('active'); });
          link.classList.add('active');
        });
      });
    });

    initInlineSearch(container);
    initCartBubble(container);
  }

  function initInlineSearch(container) {
    var wrap = container.querySelector('.header-bison-search-wrap');
    var form = container.querySelector('.header-bison-search-form');
    var input = container.querySelector('.header-bison-search-input');
    var resultsEl = container.querySelector('[data-search-results]');

    if (!wrap || !form || !input || !resultsEl) return;

    var abortController = null;
    var cachedResults = {};

    function clearResults() {
      resultsEl.innerHTML = '';
      wrap.classList.remove('has-results');
      if (abortController) abortController.abort();
    }

    function fetchResults(q) {
      var query = (q || '').trim();
      if (!query.length) {
        resultsEl.innerHTML = '';
        wrap.classList.remove('has-results');
        return;
      }
      if (abortController) abortController.abort();
      abortController = new AbortController();
      var queryKey = query.replace(/\s+/g, '-').toLowerCase();
      if (cachedResults[queryKey]) {
        resultsEl.innerHTML = cachedResults[queryKey];
        wrap.classList.add('has-results');
        return;
      }
      resultsEl.innerHTML = '<div class="predictive-search__loading-state"><div class="spinner"></div></div>';
      wrap.classList.add('has-results');
      var url = (window.routes && window.routes.predictive_search_url) || '/search/suggest';
      url += '?q=' + encodeURIComponent(query) + '&section_id=predictive-search';
      fetch(url, { signal: abortController.signal })
        .then(function(res) { return res.ok ? res.text() : Promise.reject(res.status); })
        .then(function(html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var section = doc.querySelector('#shopify-section-predictive-search');
          var markup = section ? section.innerHTML : '';
          cachedResults[queryKey] = markup;
          resultsEl.innerHTML = markup;
        })
        .catch(function(err) {
          if (err && err.code === 20) return;
          resultsEl.innerHTML = '';
          wrap.classList.remove('has-results');
        });
    }

    input.addEventListener('input', debounce(function() { fetchResults(input.value); }, 300));
    input.addEventListener('focus', function() {
      if (input.value.trim().length) fetchResults(input.value);
    });

    form.addEventListener('submit', function(e) {
      var q = input.value.trim();
      var selected = resultsEl.querySelector('[aria-selected="true"] a');
      if (selected) { e.preventDefault(); window.location.href = selected.href; }
      else if (!q) { e.preventDefault(); }
    });

    resultsEl.addEventListener('click', function(e) {
      var link = e.target.closest('a');
      if (link && link.href) { e.preventDefault(); window.location.href = link.href; return; }
      var searchForBtn = e.target.closest('.predictive-search__search-for-button button');
      if (searchForBtn && input.value.trim()) { e.preventDefault(); form.submit(); }
    });

    var openSearchBtn = container.querySelector('.icon-search-open');

    function isSearchPanelTarget(node) {
      if (!node || typeof node.closest !== 'function') return false;
      return wrap.contains(node) || (openSearchBtn && openSearchBtn.contains(node));
    }

    function setSearchOpen(open) {
      if (open) {
        container.classList.add('header-bison--search-open');
        wrap.removeAttribute('aria-hidden');
        if (openSearchBtn) openSearchBtn.setAttribute('aria-expanded', 'true');
        input.removeAttribute('tabindex');
      } else {
        container.classList.remove('header-bison--search-open');
        wrap.classList.remove('is-field-active');
        wrap.setAttribute('aria-hidden', 'true');
        if (openSearchBtn) openSearchBtn.setAttribute('aria-expanded', 'false');
        input.setAttribute('tabindex', '-1');
        if (document.activeElement === input) input.blur();
        clearResults();
      }
    }

    input.setAttribute('tabindex', '-1');
    wrap.setAttribute('aria-hidden', 'true');

    if (openSearchBtn) {
      openSearchBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        var willOpen = !container.classList.contains('header-bison--search-open');
        if (willOpen) {
          setSearchOpen(true);
          wrap.classList.add('is-field-active');
          setTimeout(function() {
            input.focus({ preventScroll: false });
            if (typeof input.scrollIntoView === 'function' && window.matchMedia('(max-width: 991px)').matches) {
              input.scrollIntoView({ block: 'center', behavior: 'smooth' });
            }
          }, 70);
          if (input.value.trim().length) fetchResults(input.value);
        } else {
          setSearchOpen(false);
        }
      });
    }

    input.addEventListener('blur', function() {
      setTimeout(function() {
        if (!container.classList.contains('header-bison--search-open')) return;
        var active = document.activeElement;
        if (wrap.contains(active) || active === openSearchBtn) return;
        setSearchOpen(false);
      }, 120);
    });

    document.addEventListener('click', function(e) {
      if (!container.classList.contains('header-bison--search-open')) {
        if (!wrap.contains(e.target) && resultsEl.innerHTML !== '') clearResults();
        return;
      }
      if (!isSearchPanelTarget(e.target)) setSearchOpen(false);
      if (!wrap.contains(e.target) && resultsEl.innerHTML !== '') clearResults();
    });

    document.addEventListener('keydown', function(e) {
      if (e.key !== 'Escape') return;
      if (!container.classList.contains('header-bison--search-open')) return;
      var active = document.activeElement;
      if (active === input || wrap.contains(active) || active === openSearchBtn) {
        e.preventDefault();
        setSearchOpen(false);
      }
    });
  }

  function initCartBubble(container) {
    var cartIcon = container.querySelector('#cart-icon-bubble');
    if (!cartIcon) return;

    function setCount(count) {
      var normalized = Number(count) || 0;
      var bubbleText = cartIcon.querySelector('.cart-count-bubble [aria-hidden="true"]');
      if (bubbleText) bubbleText.textContent = String(normalized);
      var srText = cartIcon.querySelector('.cart-count-bubble .visually-hidden');
      if (srText) srText.textContent = normalized + ' items';
    }

    function refreshFromCart() {
      fetch('/cart.js')
        .then(function(res) { return res.ok ? res.json() : Promise.reject(res.status); })
        .then(function(cart) { setCount(cart && cart.item_count); })
        .catch(function() {});
    }

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function() {
        refreshFromCart();
      });
    }
  }

  function initAll() {
    // Legacy initializer disabled to avoid conflicting listeners
    // with the modern initializer below in this file.
  }
  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', function(e) {
    // Legacy section-load initializer intentionally no-op.
  });
})();

/* assets/section-header-bison.js
   Powers:
   - Mobile hamburger drawer + overlay
   - Search field toggle (mobile)
   - Mega menu: mobile accordion + desktop "Shop -> Collections" preview
   - Predictive search via /search/suggest.json
   - Typewriter placeholder animation (data-attribute driven)
*/
(function () {
  'use strict';

  // ============ Mobile hamburger drawer ============
  function initDrawer(root) {
    const hamburger = root.querySelector('.hamburger-menu');
    const navbar = root.querySelector('.custom-navbar');
    const overlay = root.querySelector('.mobile-overlay');
    const closeBtn = root.querySelector('.close-menu');
    if (!hamburger || !navbar) return;

    const open = () => {
      hamburger.classList.add('active');
      navbar.classList.add('active');
      if (overlay) overlay.classList.add('active');
      document.body.style.overflow = 'hidden';
    };
    const close = () => {
      hamburger.classList.remove('active');
      navbar.classList.remove('active');
      if (overlay) overlay.classList.remove('active');
      document.body.style.overflow = '';
    };

    hamburger.addEventListener('click', () => {
      navbar.classList.contains('active') ? close() : open();
    });
    if (closeBtn) closeBtn.addEventListener('click', close);
    if (overlay) overlay.addEventListener('click', close);

    // Close drawer when crossing back to desktop
    window.matchMedia('(min-width: 992px)').addEventListener('change', (e) => {
      if (e.matches) close();
    });
  }

  // ============ Search toggle button (used on mobile) ============
  function initSearchToggle(root) {
    const btn = root.querySelector('.icon.icon-search-open');
    if (!btn) return;
    const input = root.querySelector('.header-bison-search-input');

    btn.addEventListener('click', () => {
      const isOpen = root.classList.toggle('header-bison--search-open');
      btn.setAttribute('aria-expanded', String(isOpen));
      if (isOpen && input) setTimeout(() => input.focus(), 60);
    });
  }

  // ============ Mega menu viewport alignment (desktop) ============
  function measureMegaMenuWidth(mega, withSelection, withProducts) {
    if (!mega) return 0;
    const content = mega.querySelector('.mega-menu-content');
    const collectionsBox = mega.querySelector('.collections-content');
    const productsBox = mega.querySelector('.products-content');
    const saved = {
      display: mega.style.display,
      visibility: mega.style.visibility,
      pointerEvents: mega.style.pointerEvents,
      megaHasSelection: mega.classList.contains('has-selection'),
      contentHasSelection: !!(content && content.classList.contains('has-selection')),
      collectionsHasSelection: !!(collectionsBox && collectionsBox.classList.contains('has-selection')),
      megaHasProducts: mega.classList.contains('has-products-selection'),
      contentHasProducts: !!(content && content.classList.contains('has-products-selection')),
      productsHasSelection: !!(productsBox && productsBox.classList.contains('has-selection')),
    };

    mega.style.visibility = 'hidden';
    mega.style.pointerEvents = 'none';
    mega.style.display = 'block';

    if (withSelection) {
      mega.classList.add('has-selection');
      if (content) content.classList.add('has-selection');
      if (collectionsBox) collectionsBox.classList.add('has-selection');
    } else {
      mega.classList.remove('has-selection');
      if (content) content.classList.remove('has-selection');
      if (collectionsBox) collectionsBox.classList.remove('has-selection');
    }

    if (withProducts) {
      mega.classList.add('has-products-selection');
      if (content) content.classList.add('has-products-selection');
      if (productsBox) productsBox.classList.add('has-selection');
    } else {
      mega.classList.remove('has-products-selection');
      if (content) content.classList.remove('has-products-selection');
      if (productsBox) productsBox.classList.remove('has-selection');
    }

    const width = mega.getBoundingClientRect().width || 0;

    mega.classList.toggle('has-selection', saved.megaHasSelection);
    if (content) content.classList.toggle('has-selection', saved.contentHasSelection);
    if (collectionsBox) collectionsBox.classList.toggle('has-selection', saved.collectionsHasSelection);
    mega.classList.toggle('has-products-selection', saved.megaHasProducts);
    if (content) content.classList.toggle('has-products-selection', saved.contentHasProducts);
    if (productsBox) productsBox.classList.toggle('has-selection', saved.productsHasSelection);

    mega.style.display = saved.display;
    mega.style.visibility = saved.visibility;
    mega.style.pointerEvents = saved.pointerEvents;
    return width;
  }

  function updateMegaMenuAlignment(root) {
    if (!root || !window.matchMedia('(min-width: 992px)').matches) return;

    const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
    const margin = 8;

    root.querySelectorAll('.custom-nav-item.has-mega').forEach((item) => {
      const mega = item.querySelector('.mega-menu');
      item.classList.remove('mega-align-right', 'mega-columns-flip', 'mega-products-flip');
      if (!mega) return;

      const narrowWidth = measureMegaMenuWidth(mega, false, false);
      const selectionWidth = measureMegaMenuWidth(mega, true, false);
      const productsOnlyWidth = measureMegaMenuWidth(mega, false, true);
      const fullWidth = measureMegaMenuWidth(mega, true, true);
      if (!narrowWidth && !selectionWidth) return;

      const shopColumnWidth = narrowWidth || 360;
      const collectionsWidth = Math.max((selectionWidth || shopColumnWidth) - shopColumnWidth, 220);
      const itemRect = item.getBoundingClientRect();

      const spaceRightOfShop = viewportWidth - margin - (itemRect.left + shopColumnWidth);
      const needsColumnsFlip = spaceRightOfShop < collectionsWidth - 1;

      if (needsColumnsFlip) {
        item.classList.add('mega-columns-flip');
        const collectionsLeft = itemRect.left - collectionsWidth;
        if (collectionsLeft < margin || itemRect.left + shopColumnWidth > viewportWidth - margin) {
          item.classList.add('mega-align-right');
        }
      } else if (itemRect.left + (selectionWidth || narrowWidth) > viewportWidth - margin) {
        item.classList.add('mega-align-right');
      }

      // Products: right (default) → align-right → left flip only if both fail.
      // Decide from the menu's current open state so plain+products items are not
      // flipped based on a wider 3-column measurement.
      const hasProducts = mega.classList.contains('has-products-selection');
      const hasSelection = mega.classList.contains('has-selection');
      const hasColumnsFlip = item.classList.contains('mega-columns-flip');

      if (hasProducts) {
        const plainTotal = productsOnlyWidth || shopColumnWidth + 360;
        const fullTotal = fullWidth || (selectionWidth || shopColumnWidth) + 380;
        const total = hasSelection ? fullTotal : plainTotal;

        if (hasColumnsFlip) {
          const productsCol = Math.max(total - shopColumnWidth, 360);
          if (spaceRightOfShop < productsCol - 1) {
            item.classList.add('mega-products-flip');
          }
        } else {
          const canLeftAlign = itemRect.left + total <= viewportWidth - margin;
          const canAlignRight = itemRect.right - total >= margin - 1;

          if (canLeftAlign) {
            // Keep default left alignment; products stay on the right.
          } else if (canAlignRight) {
            item.classList.add('mega-align-right');
          } else {
            item.classList.add('mega-products-flip');
          }
        }
      }

      const widest = Math.max(
        hasProducts && hasSelection ? fullWidth || 0 : 0,
        hasProducts && !hasSelection ? productsOnlyWidth || 0 : 0,
        hasSelection ? selectionWidth || 0 : 0,
        narrowWidth || 0
      );
      if (
        !item.classList.contains('mega-align-right') &&
        !item.classList.contains('mega-products-flip') &&
        itemRect.left + widest > viewportWidth - margin
      ) {
        item.classList.add('mega-align-right');
      }
    });
  }

  function debounce(fn, wait) {
    let timer;
    return function debounced() {
      clearTimeout(timer);
      timer = setTimeout(fn, wait);
    };
  }

  // ============ Mega menu ============
  function initMegaMenu(root) {
    const isDesktop = () => window.matchMedia('(min-width: 992px)').matches;
    const items = root.querySelectorAll('.custom-nav-item.has-mega');

    updateMegaMenuAlignment(root);
    window.addEventListener('resize', debounce(() => updateMegaMenuAlignment(root), 120));

    items.forEach((item) => {
      const link = item.querySelector('.custom-nav-link');
      const mega = item.querySelector('.mega-menu');
      if (!link || !mega) return;

      // Mobile: tap parent to toggle accordion
      link.addEventListener('click', (e) => {
        if (!isDesktop()) {
          e.preventDefault();
          items.forEach((o) => { if (o !== item) o.classList.remove('open'); });
          item.classList.toggle('open');
        }
      });

      // Desktop: hovering a "Shop" item reveals matching "Collections" panel
      const shopItems = mega.querySelectorAll('.mega-column:first-child .mega-menu-item[data-key]');
      const plainShopItems = mega.querySelectorAll('.mega-column:first-child .mega-menu-item:not([data-key])');
      const collectionsContent = mega.querySelector('.collections-content');
      const megaContent = mega.querySelector('.mega-menu-content');
      const panels = mega.querySelectorAll('.collections-panel');
      const shopColumn = mega.querySelector('.mega-column:first-child');

      // Great-grandchild: hovering a collection (grandchild) reveals its products
      const productsContent = mega.querySelector('.products-content');
      const productPanels = mega.querySelectorAll('.products-panel');
      const grandchildItems = mega.querySelectorAll('.collections-panel .mega-menu-item[data-gc-key]');
      const plainGrandchildItems = mega.querySelectorAll('.collections-panel .mega-menu-item:not([data-gc-key])');

      const showProducts = (gcKey) => {
        mega.classList.add('has-products-selection');
        if (megaContent) megaContent.classList.add('has-products-selection');
        if (productsContent) productsContent.classList.add('has-selection');
        productPanels.forEach((p) => p.classList.toggle('active', p.dataset.gcParentKey === gcKey));
        grandchildItems.forEach((g) => g.classList.toggle('active', g.dataset.gcKey === gcKey));
        if (isDesktop()) updateMegaMenuAlignment(root);
      };
      const clearProducts = () => {
        mega.classList.remove('has-products-selection');
        if (megaContent) megaContent.classList.remove('has-products-selection');
        if (productsContent) productsContent.classList.remove('has-selection');
        productPanels.forEach((p) => p.classList.remove('active'));
        grandchildItems.forEach((g) => g.classList.remove('active'));
        if (isDesktop()) updateMegaMenuAlignment(root);
      };

      const clearMobileInlinePanels = () => {
        mega.querySelectorAll('.mega-inline-panel, .mega-inline-products').forEach((panel) => panel.remove());
      };

      const clearMobileInlineProducts = () => {
        mega.querySelectorAll('.mega-inline-products').forEach((panel) => panel.remove());
        mega.querySelectorAll('.mega-grandchild.active, .mega-child--has-products.active').forEach((i) => i.classList.remove('active'));
      };

      const renderMobileInlinePanel = (key, shopItem) => {
        if (isDesktop() || !key || !shopItem || !shopColumn) return;
        clearMobileInlinePanels();
        const sourcePanel = Array.from(panels).find((p) => p.dataset.parentKey === key);
        if (!sourcePanel) return;
        const inlinePanel = sourcePanel.cloneNode(true);
        inlinePanel.classList.add('mega-inline-panel');
        shopItem.insertAdjacentElement('afterend', inlinePanel);
      };

      // Mobile: tap a collection (grandchild or plain child) to expand its products inline.
      const toggleMobileInlineProducts = (gcKey, triggerEl) => {
        if (isDesktop() || !gcKey || !triggerEl) return;
        const next = triggerEl.nextElementSibling;
        const alreadyOpen = next && next.classList.contains('mega-inline-products') && next.dataset.forKey === gcKey;
        clearMobileInlineProducts();
        if (alreadyOpen) return;
        const sourcePanel = Array.from(productPanels).find((p) => p.dataset.gcParentKey === gcKey);
        if (!sourcePanel) return;
        const clone = sourcePanel.cloneNode(true);
        clone.classList.add('mega-inline-products');
        clone.dataset.forKey = gcKey;
        triggerEl.insertAdjacentElement('afterend', clone);
        triggerEl.classList.add('active');
      };

      if (!mega.dataset.bisonMobileProductsBound) {
        mega.dataset.bisonMobileProductsBound = '1';
        mega.addEventListener('click', (e) => {
          if (isDesktop()) return;
          const trigger = e.target.closest('.mega-grandchild[data-gc-key], .mega-child--has-products[data-gc-key]');
          if (!trigger || !mega.contains(trigger)) return;
          e.preventDefault();
          e.stopPropagation();
          toggleMobileInlineProducts(trigger.dataset.gcKey, trigger);
        });
      }

      const showPanel = (key, shopItem) => {
        shopItems.forEach((s) => s.classList.toggle('active', s.dataset.key === key));
        panels.forEach((p) => p.classList.toggle('active', p.dataset.parentKey === key));
        mega.classList.add('has-selection');
        if (megaContent) megaContent.classList.add('has-selection');
        if (collectionsContent) collectionsContent.classList.add('has-selection');
        clearProducts();
        renderMobileInlinePanel(key, shopItem);
        if (isDesktop()) updateMegaMenuAlignment(root);
      };
      const clearPanels = () => {
        shopItems.forEach((s) => s.classList.remove('active'));
        panels.forEach((p) => p.classList.remove('active'));
        mega.classList.remove('has-selection');
        if (megaContent) megaContent.classList.remove('has-selection');
        if (collectionsContent) collectionsContent.classList.remove('has-selection');
        clearProducts();
        clearMobileInlinePanels();
        if (isDesktop()) updateMegaMenuAlignment(root);
      };

      grandchildItems.forEach((gc) => {
        gc.addEventListener('mouseenter', () => {
          if (isDesktop() && gc.dataset.gcKey) showProducts(gc.dataset.gcKey);
        });
      });
      plainGrandchildItems.forEach((gc) => {
        gc.addEventListener('mouseenter', () => {
          if (isDesktop()) clearProducts();
        });
      });

      shopItems.forEach((shopItem) => {
        // Mobile: only the arrow toggles the accordion; image + name navigate to the collection.
        const arrow = shopItem.querySelector('.mega-menu-arrow');
        if (arrow) {
          const togglePanel = (e) => {
            if (!isDesktop() && shopItem.dataset.key) {
              e.preventDefault();
              e.stopPropagation();
              if (shopItem.classList.contains('active')) {
                clearPanels();
              } else {
                showPanel(shopItem.dataset.key, shopItem);
              }
            }
          };
          arrow.addEventListener('click', togglePanel);
          arrow.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') togglePanel(e);
          });
        }

        shopItem.addEventListener('mouseenter', () => {
          if (isDesktop() && shopItem.dataset.key) showPanel(shopItem.dataset.key, shopItem);
        });
      });
      plainShopItems.forEach((shopItem) => {
        shopItem.addEventListener('mouseenter', () => {
          if (!isDesktop()) return;
          // Plain child that links to a collection: show its products directly.
          clearPanels();
          if (shopItem.dataset.gcKey) showProducts(shopItem.dataset.gcKey);
        });
        shopItem.addEventListener('click', () => {
          if (!isDesktop()) return;
          clearPanels();
          if (shopItem.dataset.gcKey) showProducts(shopItem.dataset.gcKey);
        });
      });
      mega.addEventListener('mouseleave', () => { if (isDesktop()) clearPanels(); });

      item.addEventListener('mouseenter', () => {
        if (isDesktop()) updateMegaMenuAlignment(root);
      });
    });
  }

  // ============ Predictive search ============
  function escapeHtml(s) {
    const d = document.createElement('div');
    d.textContent = s == null ? '' : String(s);
    return d.innerHTML;
  }

  function initPredictiveSearch(root) {
    const wrap = root.querySelector('.header-bison-search-wrap');
    if (!wrap) return;
    const input = wrap.querySelector('.header-bison-search-input');
    const results = wrap.querySelector('.header-bison-search-results');
    if (!input || !results) return;

    let aborter = null;
    let debounceId = null;

    const clearResults = () => {
      results.innerHTML = '';
      wrap.classList.remove('has-results');
    };

    const renderProducts = (products) => {
      if (!products.length) {
        results.innerHTML = '<div class="predictive-search__item" style="padding:16px;">No results</div>';
        return;
      }
      const ul = document.createElement('ul');
      ul.className = 'predictive-search__results-list';
      products.forEach((p) => {
        const li = document.createElement('li');
        li.className = 'predictive-search__list-item';
        li.innerHTML = `
          <a class="predictive-search__item" href="${escapeHtml(p.url)}">
            <h4 class="predictive-search__item-heading">${escapeHtml(p.title)}</h4>
          </a>
        `;
        ul.appendChild(li);
      });
      results.innerHTML = '';
      results.appendChild(ul);
    };

    const fetchSuggestions = async (q) => {
      if (aborter) aborter.abort();
      aborter = new AbortController();
      results.innerHTML = '<div class="predictive-search__loading-state"><div class="spinner"></div></div>';
      wrap.classList.add('has-results');
      try {
        const url = `/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=8`;
        const res = await fetch(url, { signal: aborter.signal });
        if (!res.ok) throw new Error('search failed');
        const data = await res.json();
        const products = (data.resources && data.resources.results && data.resources.results.products) || [];
        renderProducts(products);
      } catch (err) {
        if (err.name !== 'AbortError') clearResults();
      }
    };

    input.addEventListener('input', () => {
      const q = input.value.trim();
      wrap.classList.toggle('is-field-active', q.length > 0);
      clearTimeout(debounceId);
      if (q.length < 2) { clearResults(); return; }
      debounceId = setTimeout(() => fetchSuggestions(q), 200);
    });

    input.addEventListener('focus', () => {
      const q = input.value.trim();
      if (q.length >= 2) fetchSuggestions(q);
    });

    document.addEventListener('click', (e) => {
      if (!wrap.contains(e.target)) clearResults();
    });
  }

  // ============ Typewriter placeholder ============
  function initTypewriter(input) {
    if (input.dataset.placeholderAnimInit === '1') return;
    input.dataset.placeholderAnimInit = '1';

    const prompts = [
      input.dataset.placeholderOne,
      input.dataset.placeholderTwo,
      input.dataset.placeholderThree,
    ].filter(Boolean);
    if (prompts.length === 0) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      input.setAttribute('placeholder', prompts[0]);
      return;
    }

    const typingSpeed = parseInt(input.dataset.typingSpeed, 10) || 100;
    const deletingSpeed = parseInt(input.dataset.deletingSpeed, 10) || 60;
    const delayAfterDeleting = parseInt(input.dataset.delayAfterDeleting, 10) || 500;
    const delayBeforeFirstDelete = parseInt(input.dataset.delayBeforeFirstDelete, 10) || 2000;
    const delayAfterWordTyped = parseInt(input.dataset.delayAfterWordTyped, 10) || 2400;
    const enabledOnMobile = input.dataset.placeholderPromptsMob !== 'false';
    const mobileMQ = window.matchMedia('(max-width: 991px)');

    let wordIndex = 0, charIndex = 0;
    let isDeleting = false, isFirstWord = true, paused = false;
    let timer = null;

    const setPH = (t) => input.setAttribute('placeholder', t);
    const clearTimer = () => { if (timer) { clearTimeout(timer); timer = null; } };
    const showStatic = () => { clearTimer(); setPH(prompts[0]); };

    function tick() {
      if (paused) return;
      if (!enabledOnMobile && mobileMQ.matches) { showStatic(); return; }

      const word = prompts[wordIndex];
      if (!isDeleting) {
        charIndex++;
        setPH(word.slice(0, charIndex));
        if (charIndex === word.length) {
          const wait = isFirstWord ? delayBeforeFirstDelete : delayAfterWordTyped;
          isFirstWord = false;
          isDeleting = true;
          timer = setTimeout(tick, wait);
          return;
        }
        timer = setTimeout(tick, typingSpeed);
      } else {
        charIndex--;
        setPH(word.slice(0, charIndex));
        if (charIndex === 0) {
          isDeleting = false;
          wordIndex = (wordIndex + 1) % prompts.length;
          timer = setTimeout(tick, delayAfterDeleting);
          return;
        }
        timer = setTimeout(tick, deletingSpeed);
      }
    }

    const pause = () => { paused = true; clearTimer(); };
    const resume = () => {
      if (!paused) return;
      paused = false;
      if (input.value === '' && document.activeElement !== input) tick();
    };

    input.addEventListener('focus', pause);
    input.addEventListener('blur', () => { if (input.value === '') resume(); });
    input.addEventListener('input', () => { if (input.value !== '') pause(); });

    const onMQ = () => {
      if (!enabledOnMobile && mobileMQ.matches) {
        pause();
        showStatic();
      } else if (document.activeElement !== input && input.value === '') {
        paused = false;
        clearTimer();
        tick();
      }
    };
    if (mobileMQ.addEventListener) mobileMQ.addEventListener('change', onMQ);
    else mobileMQ.addListener(onMQ);

    setPH('');
    tick();
  }

  // ============ Account dropdown (hover desktop / tap mobile) ============
  function initAccountDropdown(root) {
    const dropdown = root.querySelector('[data-header-account]');
    if (!dropdown || dropdown.dataset.accountDropdownInit) return;
    dropdown.dataset.accountDropdownInit = '1';

    const trigger = dropdown.querySelector('.header-account-dropdown__trigger');
    const mobileMq = window.matchMedia('(max-width: 991.98px)');

    function setOpen(open) {
      dropdown.classList.toggle('is-open', open);
      if (trigger) trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    function close() {
      setOpen(false);
    }

    if (trigger) {
      trigger.addEventListener('click', (e) => {
        if (!mobileMq.matches) return;
        e.preventDefault();
        e.stopPropagation();
        setOpen(!dropdown.classList.contains('is-open'));
      });
    }

    document.addEventListener('click', (e) => {
      if (!dropdown.contains(e.target)) close();
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') close();
    });

    const onMqChange = () => close();
    if (mobileMq.addEventListener) mobileMq.addEventListener('change', onMqChange);
    else mobileMq.addListener(onMqChange);
  }

  // ============ Boot ============
  function boot() {
    document.querySelectorAll('.header-bison').forEach((root) => {
      initDrawer(root);
      initSearchToggle(root);
      initMegaMenu(root);
      initPredictiveSearch(root);
      initAccountDropdown(root);
    });
    document.querySelectorAll('.header-bison-search-input').forEach(initTypewriter);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
